export class BaseApiResponseModel<T extends Object> {
  constructor(
    public data?: T,
    public message?: string,
    public error?: Error,
    public code?: number,
    public paging?: Paging,
    public pagination?: Paging,
    public byteLength?: number,
    public isSuccess?: boolean
  ) {}
}

export interface Paging {
  limit: number;
  page: number;
  total: number;
}

export class Error {
  code?: number;
  message?: string;
}

export default {
  BaseApiResponseModel,
  Error,
};
